import options from "contexts/options.json"
import { useMongoQueries } from "contexts/useMongoQuery";
import { ObjectId } from 'bson';

export const useExternalClinics = () => {
  const { data, loading, error } = useMongoQueries("clinics", { _id: { $ne: new ObjectId(options.centralClinic.id)} })
  if (error) {
    throw new Error(`Failed to fetch useAllClinics`);
  }
  const clinics:KV[] = data ?? [];
  return {
    clinics,
    loading,
  }
}

// セントラル世田谷クリニックのみを抽出する
export const useInternalClinic = () => {
  const { data, loading, error } = useMongoQueries("clinics", { _id: new ObjectId(options.centralClinic.id)})
  if (error) {
    throw new Error(`Failed to fetch useAllClinics`)
  }
  const internalClinic:KV[] = data ?? []
  return {
    internalClinic,
    loading,
  }
}